import checkHTML from '../string/checkHTML.js';

import staticContent from './staticContent.js';

const staticContentPropCheck = (props, propName, componentName) => {
  const propValue = props[propName];
  const valueToCheck =
    Array.isArray(propValue) && typeof propValue[0] === 'string'
      ? propValue[0]
      : propValue;

  if (typeof valueToCheck !== 'string') {
    return null;
  }

  if (checkHTML(valueToCheck)) {
    return new Error(
      `String containing markup provided as prop "${propName}" to ${componentName}. ${componentName} will no longer parse markup. See the migration guide for more info https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/blob/main/migration.md#migrating-from-29-to-30`
    );
  }

  try {
    staticContent.get(valueToCheck);
  } catch (e) {
    return null;
  }

  return new Error(
    `Static content key "${valueToCheck}" provided as prop "${propName}" to ${componentName}. ${componentName} will no longer convert static content keys. See the migration guide for more info https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/blob/main/migration.md#migrating-from-29-to-30`
  );
};

const requiredStaticContentPropCheck = (props, propName, componentName) => {
  const propValue = props[propName];
  if (typeof propValue === 'undefined') {
    return new Error(
      `Missing required "${propName}" prop in ${componentName} component`
    );
  }
  return staticContentPropCheck(props, propName, componentName);
};

staticContentPropCheck.isRequired = requiredStaticContentPropCheck;

export default staticContentPropCheck;
